import React from "react";
import { Link } from "react-router-dom";
import BaseLayout from "../components/BaseLayout";

const Welcome: React.FC = () => {
  return (
    <BaseLayout>
      <div className="min-h-screen flex flex-col items-center">
        <h1 className="text-4xl font-bold mb-5 mt-40 text-center">
          <span className="text-highlight font-rubik">Alexander Eckinger</span>
        </h1>
        <div className="flex flex-col items-center space-y-5">
          <Link to="/photos" className="relative">
            <span className="btn-shadow"></span>
            <span className="btn-main font-rubik">Photos</span>
          </Link>
          <Link to="/reading" className="relative">
            <span className="btn-shadow"></span>
            <span className="btn-main font-rubik">Reading</span>
          </Link>
          <Link to="/bio" className="relative">
            <span className="btn-shadow"></span>
            <span className="btn-main font-rubik">Bio</span>
          </Link>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Welcome;
